import React from "react";
import { SelectFilters } from "./partials/Selects";
import { ValidityPeriod } from "./partials/ValidityPeriod";
import { useMediaQuery, query } from "@/hooks/useMediaQuery";
import { FilterIndicator } from "./partials/FilterIndicator";
import { Wrapper, Content, Divider, Container, Overlay } from "./styles";
import { useFloatingFilterButton } from "@/services/zustand/flotingFilterButton";

export const TypesFilterPlans: React.FC = () => {
  const toggle = useFloatingFilterButton((state) => state.toggle);
  const filterIsOpen = useFloatingFilterButton((state) => state.open);

  const { isMobile } = useMediaQuery(query);

  return (
    <>
      {filterIsOpen && isMobile && <Overlay onClick={toggle} />}
      <Container isOpen={filterIsOpen}>
        <Wrapper>
          <Content>
            <FilterIndicator />
            <Divider />
            <SelectFilters />
            <ValidityPeriod />
          </Content>
        </Wrapper>
      </Container>
    </>
  );
};
